<!-- =========================================================================================
  File Name: receive.vue
  Description: Money Receive
========================================================================================== -->

<template>
  <div id="money-receive">

    <vx-card title="收款银行">

      <div slot="actions">
        <vs-button size="small" color="success" type="filled" @click="add">添加新收款银行卡</vs-button>
      </div>

      <vs-table stripe :data="list" noDataText="暂无银行卡">
        <template slot="thead">
          <vs-th width="90">ID</vs-th>
		  <vs-th width="90">UID</vs-th>
		  <vs-th width="90">用户名</vs-th>
          <vs-th width="150">银行名称</vs-th>
          <vs-th width="150">银行类型</vs-th>
          <vs-th width="200">开户行</vs-th>
          <vs-th width="150">开户姓名</vs-th>
          <vs-th width="200">银行卡号</vs-th>
          <vs-th width="200">额度限制 (元)</vs-th>
          <vs-th width="120">二维码</vs-th>
          <vs-th width="100">状态</vs-th>
          <vs-th width="200">排序(数值越小越靠前)</vs-th>
          <vs-th width="200">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
			<vs-td :data="item.uid">{{item.uid}}</vs-td>
			<vs-td :data="item.username">{{item.username}}</vs-td>
            <vs-td :data="item.bank">{{item.bank}}</vs-td>
            <vs-td :data="item.icon">{{bankList[item.icon]}}</vs-td>
            <vs-td :data="item.open">{{item.open}}</vs-td>
            <vs-td :data="item.name">{{item.name}}</vs-td>
            <vs-td :data="item.code">{{item.code}}</vs-td>
            <vs-td :data="item.min">{{item.min}} - {{item.max}}</vs-td>
            <vs-td :data="item.qrcode">
              <img :src="item.qrcode" class="w-12 cursor-pointer" v-if="item.qrcode !== ''" @click="modify" :data-index="index" />
              <span v-else>未上传</span>
            </vs-td>
            <vs-td :data="item.enable">{{item.enable == 1 ? '开启' : '关闭'}}</vs-td>
            <vs-td :data="item.order">{{item.order}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-3">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex !== -1 ? '更改银行信息' : '添加银行信息'" @confirm="submit">
      <div class="p-4">
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.uid" label="用户ID" />
		</div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.bank" label="银行名称" />
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.icon" label="银行类型">
            <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in bankList" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.open" label="开户行" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.name" label="开户姓名" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.code" label="银行卡号" />
        </div>
        <div class="mb-4 vx-row">
          <div class="vx-col sm:w-1/2">
            <vs-input class="w-full" v-model="modifyItem.min" label="最低充值 (元)" />
          </div>
          <div class="vx-col sm:w-1/2">
            <vs-input class="w-full" v-model="modifyItem.max" label="最高充值 (元)" />
          </div>
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.enable" label="状态">
            <vs-select-item value="1" text="开启" />
            <vs-select-item value="0" text="关闭" />
          </vs-select>
        </div>
        <div class="mb-8">
          <vs-input class="w-full" v-model="modifyItem.order" label="排序 (数值越小越靠前)" />
        </div>
        <div class="mb-4">
          <div class="vs-input--label">上传二维码</div>
          <div class="upload-img mt-2 w-48 cursor-pointer" v-if="modifyItem.qrcode !== ''" title="点击重新上传" @click="reUpload">
            <img :src="modifyItem.qrcode" class="w-48" />
            <div class="hover-close">X</div>
          </div>
          <vs-input class="w-full" type="file" @change="uploadToBase64" v-if="modifyItem.qrcode === ''" />
        </div>
      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      bankList: []
    }
  },
  components: {
    modifySiderBar
  },
  methods: {
    uploadToBase64 (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image') === -1 || file.size / 1000 > 2048) {
        this.$vs.dialog({
          title: '提示',
          text: '格式必须为图片, 且大小不能超过2M',
          acceptText: '确认'
        })
        this.modifyItem.qrcode = ''
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (e) => {
        this.modifyItem.qrcode = e.target.result
      }
    },
    reUpload () {
      this.modifyItem.qrcode = ''
    },
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    add () {
      this.modifyIndex = -1
      this.modifyItem = { id: -1, icon: 'virtual', open: 'USDT', name: 'USDT', enable: 1, order: 0, qrcode: '',uid:'',bank:'USDT_TRC20',min:'500',max:'1000000' }
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('money-bankReceiveDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该银行信息吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('money-bankReceiveDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    load() {
      this.$utils.post('money-bankReceiveList', { authKey: localStorage.getItem('authKey') }).then(res => {
        this.list = res
      })
    }
  },
  mounted () {
    this.load()
    // 获取银行卡列表
    this.$utils.post('money-bankList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.bankList = res
    })
  }
}
</script>

<style>
  .upload-img {
    position: relative;
    display: block;
  }
  .upload-img .hover-close {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    color: #fff;
    font-size: 40px;
    z-index: 1;
    display: none;
  }
  .upload-img:hover .hover-close {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
